﻿import creator from '../elementCreator';
import globals from '../globals';
import layerhelp from './helptextgenerator';
import GeoJSON from 'ol/format/GeoJSON.js';
import VectorWMS from 'ol/source/Vector.js';
import Cluster from 'ol/source/Cluster.js';
import {all} from 'ol/loadingstrategy';
import WebGLPointsLayer from 'ol/layer/WebGLPoints.js';
"use strict";
var privateFns;
privateFns = {
	forEachRecursive: function (lyr, fn) {
		lyr.getLayers().forEach(
			/**
			* @param {{getLayers:method}} lyr
			* @param idx
			* @param a
			*/
			function (lyr, idx, a) {
				fn(lyr, idx, a);
				if (lyr.getLayers) {
					privateFns.forEachRecursive(lyr, fn);
				}
			}
		);
	},
	addQuickSearch: function(target){
		var modeSelect = creator.createSelect({id: "quickSearch"});
		var label = creator.createLabel({htmlfor: "quickSearch", text: "Hurtigvalg: "});
		Object.keys(globals.modes).filter(mode => globals.modes[mode].layers && globals.modes[mode].displayName).forEach(function(mode){
			mode = globals.modes[mode];
			let textValue = mode.displayName ? mode.displayName : mode.mode;
			var opt = creator.createOption({text: textValue, value: mode.mode});
			modeSelect.appendChild(opt);
		});
		modeSelect.onchange = function(e){
			var mode = this.value;
			privateFns.turnOffAllLayers();
			if (globals.modes[mode].layers) {
				if(Array.isArray(globals.modes[mode].layers)){
					globals.modes[mode].layers.forEach(function(layer){
						if($("#"+layer).length){
							$("#"+layer).click();
							//privateFns.toggleRecursive(layer, true, true);
						}
					});
				}else{
					globals.modes[mode][0]();
				}
			}
			globals.mapMode = mode;
			history.replaceState({}, "planinnsyn", window.location.href.split("?")[0].split("#")[0] + "?mode=" + this.value);
		}
		target.appendChild(label);
		target.appendChild(modeSelect);
	},
	turnOffAllLayers: function(){
		privateFns.forEachRecursive(globals.map, function(l){
			var layer = l.values_.layerId;
			if($("#"+layer)[0] && $("#"+layer)[0].checked && !$("#"+layer)[0].parentElement.parentElement.firstChild.classList.contains("mapmenu-expander")){
				$("#"+layer).click();
				privateFns.toggleRecursive(layer, true, false);
			}
		});
	},
	addMapmenu: function () {
		let nav = creator.createNav({css: "mapmenu", id: "mapmenu"});
		let wrapper = creator.createDiv({css: "mapmenu-wrapper"});
		let container = creator.createDiv({id: "mapmenu-ct"});
		wrapper.appendChild(container);				
		if(globals.appConfig.quickSearch){
			privateFns.addQuickSearch(container);				
		}
		nav.appendChild(wrapper);
		$("#header").after(nav);
	},
	addNavToggler: function (header) {
		var div = creator.createDiv({ id: "navToggler", css: "navtoggler navtogglerStyler navtogglerActive"});
		div.appendChild(creator.createButton({
			css: "buttonToggler",
			id: "layerMenuToggler",
			text: "<span id = 'spanToggler' class = 'spanTogglerRemove'>" + header + "</span><i class='icon-Close' style=\"padding-top: 10px;\"></i>",
			onclick: function (e) {
				$("#navToggler").toggleClass("navtoggler-toggled").toggleClass("navtogglerActive");
				$("#navToggler").find("i").toggleClass("icon-Menu").toggleClass("icon-Close");
				$("#spanToggler").toggleClass("spanTogglerActive").toggleClass("spanTogglerRemove");
				$(".mapmenu").toggleClass("nav-toggled");
			}
		}));
		$("#header").after(div);
	},
	createLayerMenuContainer: function (header) {
		privateFns.addMapmenu();
		privateFns.addNavToggler(header);
	},
	loopLayers: function (layers, target) {
		layers.forEach(function (l) {
			if (l.layers) {
				var groupContainer = privateFns.createGroupContainer(l);
				if (l.groupCheckbox) {
					target.appendChild(privateFns.createLayerElement(l));
					if(l.legend){
						target.appendChild(privateFns.createLegendLi(l));
					}
				} else if (l.title) {
					target.appendChild(privateFns.createGroupTitle(l));
				}
				target.appendChild(groupContainer);
				privateFns.loopLayers(l.layers, groupContainer);
			} else {
				/* Enkeltkartlag */
				if(l.displayInLayerMenu){						
					target.appendChild(privateFns.createLayerElement(l));
					if(l.legend){
						target.appendChild(privateFns.createLegendLi(l));
					}
				}else if(l.hiddenToggle){
					let hiddenToggleBox = privateFns.createLayerElement(l);
					$(hiddenToggleBox).hide();
					target.appendChild(hiddenToggleBox);
				}
				if (l.calendar) {
					privateFns.createCalendarInput(
						l.layerId,
						l.maxDateTo,
						l.minDateFrom,
						l.url
					);
				}
				if(l.webGlFilter){
					privateFns.createFilterInput(l);
				}
				
				if(l.olType === "text"){
					target.appendChild(privateFns.createTextField(l.text));
				}
			}
		});
	},
	createGroupTitle: function (l) {
		var title = creator.createH3({text: l.title, id: l.layerId});
		if (l.groupCheckbox === false && l.collapsible) {
			title.appendChild(privateFns.createGroupExpander());
		}
		return title;
	},
	createGroupContainer: function (l) {
		var ul = creator.createUl({id: l.layerId + "-ct", css: l.collapsible ? "collapsed-layer-ct" : "sub-layer-group"});
		return ul;
	},
	createLegendLi: function(l){
		var li = creator.createLi({});
		var wrapper = creator.createDiv({id: "layer" + l.layerId + "-legend"});
		var img = creator.createImage({src: l.legend});
		wrapper.appendChild(img);
		li.appendChild(wrapper);
		return li;
	},
	createTextField: function(l){
		var li = creator.createLi({});
		var wrapper = creator.createDiv({});
		var p = creator.createParagraph({text: l});
		wrapper.appendChild(p);
		li.appendChild(wrapper);
		return li;
	},
	createLayerElement: function (l) {
		var li = creator.createLi({});
		var wrapper = creator.createDiv({id: "layer" + l.layerId + "-ct"});
		
		var input = creator.createInput({});
		if (l.radio) {
			input.type = "radio";
			input.name = l.parentId;
		} else {
			input.type = "checkbox";
		}
		input.id = l.layerId;
		input.checked = l.visible;
		$(input).click(function (e) {
			if (e.currentTarget.indeterminate) {
				$(e.currentTarget).data("inditerm", true);
			} else {
				if ($(e.currentTarget).data("inditerm")) {
					this.checked = false;
					var evt = document.createEvent("HTMLEvents");
					evt.initEvent("change", false, true);
					this.dispatchEvent(evt);
				}
				$(e.currentTarget).data("inditerm", false);
			}
		}).change(privateFns.onChangeSetVisible);

		var label = creator.createLabel({htmlfor: l.layerId, text: l.title});
		if (l.layerInfo) {
			label.appendChild(privateFns.createLayerInfoButton(l));
		}
		label.appendChild(privateFns.appendLoader());

		wrapper.appendChild(input);
		wrapper.appendChild(label);

		if (l.layers) {
			var title;
			if (l.title.indexOf("<") !== -1) {
				title = l.title.substring(0, 9);
			} else {
				title = l.title;
			}
			li.appendChild(privateFns.createGroupExpander(title));
		}
		li.appendChild(wrapper);

		return li;
	},
	appendLoader: function () {
		return creator.createIcon({css: "layerloader fa fa-spinner fa-pulse"});
	},
	createLayerInfoButton: function (l) {
		var customLayerInfo = l.customLayerInfo;
		var button = creator.createButton({
			text: "Mer info", 
			css: "mapmenu-info", 
			onclick: function (e) {
				$(".navtoggler").toggleClass("navtoggler-toggled");
				$(".mapmenu").toggleClass("nav-toggled");

				$(".layerinfo").toggleClass("layerinfo-show");
				if (customLayerInfo) {
					$("#layerinfo-ct").html(customLayerInfo);
				} else {
					$("#layerinfo-ct").html(layerhelp.getInfoTextFor(e.currentTarget.parentElement.previousSibling.id));
				}
				e.preventDefault();
			}
		});
		return button;
	},
	createGroupExpander: function (title) {
		var button = creator.createButton({css: "mapmenu-expander", ariaLabel: "Vis " + title});
		button.appendChild(creator.createIcon({css: "icon-Chevron-down"}));

		button.onclick = function (e) {
			if(e.currentTarget){				
				if (e.currentTarget.parentElement.nodeName === "LI") {
					var label = e.currentTarget.parentElement.lastChild.lastChild.firstChild.textContent;
					privateFns.toggleAriaLabel(button, label);
					// Går gjennom alle ekspander-knappene i kartlagsmenyen
					$(".mapmenu").find(".mapmenu-expander").each(function (index, el) {
						var currentUl = e.currentTarget.parentElement.nextSibling;
						var thisUl = el.parentElement.nextSibling;
						if (el === e.currentTarget && index >= 0) {
							// hvis knappen er den det ble trykket på (index >= 0 er bare for å unngå feilmelding på ubrukt variabel..)
							$(el).find("i").toggleClass("icon-Chevron-down").toggleClass("icon-Chevron-upFill");
							$(currentUl).toggle();
						} else if ($(thisUl).find("#" + currentUl.id).length === 0) {
							// hvis knappen ikke er den det ble trykket på og ikke er foreldre til knappen det ble trykket på
							//$(el).find("i").toggleClass("oslo-chevron-down").toggleClass("oslo-chevron-up");
							//$(thisUl).hide();
						}
					});
				} else {
					var label2 = e.currentTarget.parentElement.textContent;
					privateFns.toggleAriaLabel(button, label2);
					$(e.currentTarget).find("i").toggleClass("icon-Chevron-down").toggleClass("icon-Chevron-upFill");
					$(e.currentTarget.parentElement.nextSibling).toggle();
				}
			}else if(e.target){
				var label2 = e.target.parentElement.textContent;
					privateFns.toggleAriaLabel(button, label2);
					$(e.target).find("i").toggleClass("icon-Chevron-down").toggleClass("icon-Chevron-upFill");
					$(e.target.parentElement.nextSibling).toggle();
			}
		};

		return button;
	},
	toggleAriaLabel: function (button, label) {
		if (button.getAttribute("aria-label").indexOf("Vis") > -1) {
			button.setAttribute("aria-label", "Skjul " + label);
		} else {
			button.setAttribute("aria-label", "Vis " + label);
		}
	},
	createLayerinfoPage: function () {
		var page = creator.createAside({css: "layerinfo"});
		var topDiv = creator.createDiv({css: "top-div"});
		topDiv.appendChild(creator.createButton({
			className: "close-me",
			ariaLabel: "Skjul kartlagsinformasjon",
			icon: true,
			iconClass: "icon-Close",
			onclick: function () {
				$(page).removeClass("layerinfo-show");
				$(".navtoggler").toggleClass("navtoggler-toggled");
				$(".mapmenu").toggleClass("nav-toggled");
				$("#layerinfo-ct").html("");
			}
		}));
		page.appendChild(topDiv);
		page.appendChild(creator.createSection({
			css: "layerinfoContainer",
			id: "layerinfo-ct"
		}));
		$(".mapmenu").after(page);
	},
	specialSetVisible(layer, visible){
		if(!layer.get("conditional")){
			layer.setVisible(visible);
		}
		if(layer.get("dependent")) {
			privateFns.specialSetVisible(globals.map.getLayerById(layer.get("dependent")), visible);
		}
		if(layer.get("exclude")){
			privateFns.specialSetVisible(globals.map.getLayerById(layer.get("exclude")), !visible);
		}
		if(layer.get("conditional")){
			if(visible){					
				if(globals.map.getLayerById(layer.get("conditional").condition).getVisible()){
					privateFns.specialSetVisible(globals.map.getLayerById(layer.get("conditional").trigger), visible);
				}else{
					layer.setVisible(visible);
				}
			}else{
				privateFns.specialSetVisible(globals.map.getLayerById(layer.get("conditional").trigger), visible);
				layer.setVisible(visible);
			}
		}
	},
	onChangeSetVisible: function (e) {
		var target = e.currentTarget || e.target;

		var layerId = target.id;
		/* Setter sjekkbokser i kontekstmenyen hvis kartet finnes der */
		privateFns.toggleContextMenuLayerCheckbox(layerId, target.checked);
		
		var layer = globals.map.getLayerById(layerId);
		privateFns.specialSetVisible(layer, target.checked);
		if(document.getElementById("layer" + layerId + "-legend")){
			if(target.checked){
				document.getElementById("layer" + layerId + "-legend").style.display = "block";
			}else{
				document.getElementById("layer" + layerId + "-legend").style.display = "none";
			}
		}
		
		if (target.type === "radio") {
			privateFns.forEachRecursive(globals.map, function (l) {
				if (l !== layer && l.get("parentId") === layer.get("parentId") && l.get("radio")) {
					l.setVisible(false);
					if (l.get("groupCheckbox")) {
						privateFns.cascadeSubLayers(l, false);
						privateFns.collapseGroup(l);
					}
				}
			});
		}

		/* Slår av eller på underkartlag hvis layer er et gruppekartlag */
		if (layer.get("groupCheckbox")) {
			privateFns.cascadeSubLayers(layer, target.checked);
			if (target.checked) {
				privateFns.expandGroup(layer);
			} else {
				privateFns.collapseGroup(layer);
			}
		}

		/* Slår av eller på gruppekartlag hvis layeret er et underkartlag */
		if (layer.get("parentId")) {
			privateFns.toggleParentLayer(layer);
		}

		/* Viser kalender for kalenderkartlag */
		if (layer.get("calendar")) {
			var calendar = $("#" + layerId + "-kalender");
			if (target.checked) {
				calendar.show();
			privateFns.setSelectedCalendarDates(layerId);
			} else {
				calendar.hide();
			}
		}
		/* Viser filter */
		if (layer.values_.webGlFilter) {
			var filter = $("#" + layerId + "-filter");
			if (target.checked) {
				filter.show();
				privateFns.setSelectedCalendarDates(layerId);
			} else {
				filter.hide();
			}
		}

		/* Viser dataeier nederst i kartvinduet hvis eksternt kartlag */
		if (layer.get("attribution")) {
			privateFns.toggleAttribution(layer, layer.getVisible());
		}
	},
	toggleContextMenuLayerCheckbox: function (id, checked) {
		$("#eie-content-show-" + id).prop("checked", checked);
		$("#punkt-content-show-" + id).prop("checked", checked);
	},
	cascadeSubLayers: function (group, visible) {
		group.getLayers().forEach(function (layer) {
			if (visible && !layer.get("dontCascade") ){
				layer.setVisible(visible);
				if(layer.values_.exclude){
					globals.map.getLayerById(layer.values_.exclude).setVisible(!visible);
				}
				if(layer.values_.dependent){
					globals.map.getLayerById(layer.values_.dependent).setVisible(visible);
				}
				$("#" + layer.get("layerId")).prop("checked", visible);
				/* Setter sjekkbokser i kontekstmenyen hvis kartet finnes der */
				privateFns.toggleContextMenuLayerCheckbox(layer.get("layerId"), visible);

				if (layer.getLayers) {
					privateFns.cascadeSubLayers(layer, visible);
				}
			} else if(!layer.get("dontCascade")) {
				group.getLayers().forEach(function (layer) {
					layer.setVisible(visible);
					if(layer.values_.dependent){
						globals.map.getLayerById(layer.values_.dependent).setVisible(visible);
					}
					if(layer.values_.exclude){
						globals.map.getLayerById(layer.values_.exclude).setVisible(!visible);
					}
					$("#" + layer.get("layerId")).prop("checked", visible);
					/* Setter sjekkbokser i kontekstmenyen hvis kartet finnes der */
					privateFns.toggleContextMenuLayerCheckbox(layer.get("layerId"), visible);

					if (layer.getLayers) {
						privateFns.cascadeSubLayers(layer, visible);
					}
				});
			};
			if (layer.get("attribution")) {
				privateFns.toggleAttribution(layer, visible);
			}
		});
	},
	expandGroup: function (layer) {
		$("#" + layer.get("layerId")).closest("li").find(".mapmenu-expander").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
		$("#" + layer.get("layerId") + "-ct").show();
	},
	collapseGroup: function (layer) {
		$("#" + layer.get("layerId")).closest("li").find(".mapmenu-expander").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
		$("#" + layer.get("layerId") + "-ct").hide();
	},
	toggleParentLayer: function (layer) {
		var parentLayer = globals.map.getLayerById(layer.get("parentId"));
		var visibleSubLayer = privateFns.getVisibleLayer(parentLayer);
		parentLayer.setVisible(visibleSubLayer);
		var indeterminate = privateFns.getIndeterminateCheckboxState(parentLayer);
		var checkbox = $("#" + layer.get("parentId"));
		checkbox.prop("checked", visibleSubLayer);
		checkbox.prop("indeterminate", indeterminate);
		if(visibleSubLayer){
			if($("#"+layer.get("parentId")).find(".mapmenu-expander").find("i").length > 0){
				if($("#"+layer.get("layerId")).parent().parent().next()[0]){					
					$("#"+layer.get("layerId")).parent().parent().next()[0].style.display = "block";
				}
				if($("#"+layer.get("layerId")).parent().parent().find("i").hasClass("icon-Chevron-down")){					
					$("#"+layer.get("layerId")).parent().parent().find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
				}
			}
			if($("#"+layer.get("parentId")).closest("li").closest("li").find(".mapmenu-expander") && document.getElementById(layer.get("parentId"))){
				document.getElementById(layer.get("parentId")).nextSibling.style.display = "block";
			}
		}
		if (parentLayer.get("parentId")) {
			privateFns.toggleParentLayer(parentLayer);
		}else{
			if(visibleSubLayer){
				if($("#"+layer.get("parentId")).closest("li").closest("li").find(".mapmenu-expander") && document.getElementById(layer.get("parentId"))){
					document.getElementById(layer.get("parentId")).nextSibling.style.display = "block";
				}
			}
		}
	},
	getVisibleLayer: function (parent) {
		var visible = false;
		if (parent.getLayers) {
			parent.getLayers().forEach(function (l) {
				if (l.getVisible()) {
					visible = true;
				}
			});
		} else {
			visible = parent.getVisible();
		}
		return visible;
	},
	getIndeterminateCheckboxState: function (parent) {
		var indeterminate = false, checked = "no", unchecked = "no";
		if (parent.getLayers) {
			parent.getLayers().forEach(function (l) {
				if (l.getVisible()) {
					checked = "yes";
				} else {
					unchecked = "yes";
				}
			});
		}
		if (checked === "yes" && unchecked === "yes") {
			indeterminate = true;
		}
		return indeterminate;
	},        
	toggleDefaultLayers: function () {
		if(window.location.href.indexOf("mode") == -1){			
			globals.defaults.forEach(function(layer){
				$("#"+layer).click();	
				$("#"+layer).click();
			});
		}
	},    
	toggleRecursive: function(layer, first, on){
		if(on){
			if(document.getElementById(layer) && document.getElementById(layer).closest("li")){
				document.getElementById(layer).closest("li").parentNode.style.display = "block";
				if(document.getElementById(layer).closest("li").closest("ul").previousSibling.querySelectorAll("input[type=checkbox]")[0]){
					document.getElementById(layer).closest("li").closest("ul").previousSibling.querySelectorAll("input[type=checkbox]")[0].indeterminate = true;							
				}
				if(first && $("#"+layer).closest("li").closest("li").find(".mapmenu-expander")){
					document.getElementById(layer).closest("li").nextSibling.style.display = "block";
				}
				$("#"+layer).closest("li").closest("li").find(".mapmenu-expander").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
			if(document.getElementById(layer) && document.getElementById(layer).closest("li") && document.getElementById(layer).closest("li").closest("ul").previousSibling.nodeName !== "H3"){
				privateFns.toggleRecursive(document.getElementById(layer).closest("li").closest("ul").previousSibling.querySelectorAll("input[type=checkbox]")[0].id, false, on);
			}else{
				$("#"+layer).find(".mapmenu-expander").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
				if(first && $("#"+layer).closest("li").closest("li").find(".mapmenu-expander") && document.getElementById(layer)){
					document.getElementById(layer).nextSibling.style.display = "block";
				}
			}
		}else{
			if(document.getElementById(layer) && document.getElementById(layer).closest("li")){
				document.getElementById(layer).closest("li").parentNode.style.display = "none";
				if(document.getElementById(layer).closest("li").closest("ul").previousSibling.querySelectorAll("input[type=checkbox]")[0]){
					document.getElementById(layer).closest("li").closest("ul").previousSibling.querySelectorAll("input[type=checkbox]")[0].indeterminate = false;							
				}
				$("#"+layer).closest("li").closest("li").find(".mapmenu-expander").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
			}
			if(document.getElementById(layer) && document.getElementById(layer).closest("li") && document.getElementById(layer).closest("li").closest("ul").previousSibling.nodeName !== "H3"){
				privateFns.toggleRecursive(document.getElementById(layer).closest("li").closest("ul").previousSibling.querySelectorAll("input[type=checkbox]")[0].id, false, on);
			}else{
				$("#"+layer).find(".mapmenu-expander").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
			}
		}
	},
	createCalendarInput: function (id, maxDateTo, maxDateFrom, postlisteUrl) {
		var holder = creator.createDiv({id: id + "-kalender", css: "calendar-container"});

		var calendarHeader = creator.createH4({text: "Periode"});
		holder.appendChild(calendarHeader);

		var warningDiv = creator.createDiv({css: "calendar-error"});
		holder.appendChild(warningDiv);

		privateFns.addDateInput(id + "-from-date", "Fra", "from-date", holder);
		privateFns.addDateInput(id + "-to-date", "Til", "to-date", holder);

		var antallDiv = creator.createDiv({css: "calendar-count"});
		holder.appendChild(creator.createBr({}));
		holder.appendChild(antallDiv);

		var button = creator.createSpan({
			type: "button",
			css: "ct-span-btn",
			text: "Oppdater kart",
			onclick: function () {
				privateFns.updateCalendarLayer(id, postlisteUrl);
			}			
		});
		holder.appendChild(button);

		$("#" + id).parent().parent().append(holder);
		$.fn.datepicker.defaults.format = "dd.mm.yyyy";
		$("#" + id + "-to-date-container").datepicker({
			format: 'dd.mm.yyyy',
			showOtherMonths: true,
			selectOtherMonths: false,
			maxDate: maxDateTo,
		});
		$("#" + id + "-from-date-container").datepicker({
			format: 'dd.mm.yyyy',
			showOtherMonths: true,
			selectOtherMonths: false,
			maxDate: maxDateFrom
		});
	},
	addDateInput: function (id, html, name, target) {
		var container = creator.createDiv({css: "input-group date datepicker", id: id + "-container"});
		
		var label = creator.createLabel({htmlfor: id, text: html});
		target.appendChild(label);
		
		var input = creator.createInput({type: "text", id: id, name: name, css: "form-control"});
		container.appendChild(input);
		
		var span = creator.createSpan({css: "input-group-addon"});
		container.appendChild(span);
		
		var icon = creator.createIcon({css: "icon-Kalender"});
		span.appendChild(icon);
		
		container.appendChild(span);
		
		target.appendChild(container);
		
	},
	setSelectedCalendarDates: function (id) {
		var fromDateInput = $("#" + id + "-from-date");
		var toDateInput = $("#" + id + "-to-date");
		if (fromDateInput.datepicker("getDate") === null) {
			var lowerDate = new Date();
			lowerDate.setDate(lowerDate.getDate() - 9);
			fromDateInput.datepicker("setDate", lowerDate);
		}
		if (toDateInput.datepicker("getDate") === null) {
			var upperDate = new Date();
			upperDate.setDate(upperDate.getDate() - 2);
			toDateInput.datepicker("setDate", upperDate);
		}
	},
	updateCalendarLayer: function (id, postlisteUrl) {
		var calendar = $("#" + id + "-kalender");
		calendar.find(".calendar-count").html("<p>Antall dokumenter: ...</p>");
		var fromInput = $("#" + id + "-from-date");
		var toInput = $("#" + id + "-to-date");
		var warningDiv = calendar.find(".calendar-error");
		warningDiv.empty();
		var fromDate = globals.formatDate(fromInput.datepicker("getDate"));
		var toDate =  globals.formatDate(toInput.datepicker("getDate"));
		var goOn = true;
		if (fromDate === "" || toDate === "") {
			warningDiv.html("<p>Det må velges en dato i begge felt.</p>");
			goOn = false;
		} else if (fromDate > toDate) {
			warningDiv.html("<p>Fra dato må være tidligere enn til dato.</p>");
			fromInput.datepicker("setDate", null);
			toInput.datepicker("setDate", null);
			goOn = false;
		}

		if (goOn) {
			var layer = globals.map.getLayerById(id);
			var newSource;
			newSource = new VectorWMS({
				loader: function () {
				var url = postlisteUrl + "&outputformat=geojson&srs=EPSG:4326&typename=postliste_dato&Filter=<Filter><PropertyIsBetween><PropertyName>D</PropertyName>";
				url += "<LowerBoundary>" + fromDate + "</LowerBoundary>";
				url += "<UpperBoundary>" + toDate + "</UpperBoundary></PropertyIsBetween>";
				url += "</Filter>";
				privateFns.toggleLayerLoader(id, "inline-block");
				$.ajax({
					url: url,
					dataType: "json",
					jsonp: true,
					success: function (r) {
						var f = new GeoJSON();
						privateFns.toggleLayerLoader(id, "none");
						var features = f.readFeatures(r);
						newSource.addFeatures(features);
						calendar.find(".calendar-count").html("<p>Antall dokumenter: " + features.length + "</p>");
					},
					fail: function (r) {
						console.error(r);
						privateFns.toggleLayerLoader(id, "none");
						calendar.find(".calendar-count").html("<p>Antall dokumenter: 0</p>");
					},
					error: function () {
						privateFns.toggleLayerLoader(id, "none");
						calendar.find(".calendar-count").html("<p>Antall dokumenter: 0</p>");
					}
				});
				},
				strategy: all
			});
			var newClusterSource = new Cluster({
			distance: 30,
			source: newSource
			});
			layer.setSource(newClusterSource);
		}
	},
	createFilterInput: function (layer) {
		let id = layer.layerId;
		let holder = creator.createDiv({id: id + "-filter", css: "filter-container"});
		$("#" + id).parent().append(holder);
		if(layer.webGlFilter.filter && layer.webGlFilter.filter[0] === "between"){
			let min = layer.webGlFilter.variables.min;
			let max = layer.webGlFilter.variables.max;
			
			const minSlider = creator.createInput({css: "filterInput, filter-min", id: id + "-min", text:  "Min", type: "range", min: min, max: max, value: min, onchange: function(e, val){
				privateFns.controlFromSlider(minSlider, maxSlider, id);
			}});
			const maxSlider = creator.createInput({css: "filterInput", id: id + "-max",text:  "Maks", type: "range", min: min, max: max, value: max, onchange: function(e, val){
				privateFns.controlToSlider(minSlider, maxSlider, id);
			}});
			
			holder.appendChild(minSlider);
			holder.appendChild(maxSlider);
			holder.appendChild(creator.createLabel({id: id + "-min-label", css: "filter-min-label", text: min, labelFor: id + "-min"}));
			holder.appendChild(creator.createLabel({id: id + "-max-label", css: "filter-max-label", text: max, labelFor: id + "-max"}));

			privateFns.fillSlider(minSlider, maxSlider, '#C6C6C6', '#25daa5', minSlider);
			privateFns.setToggleAccessible(maxSlider, id + "-max");
		}else if(layer.webGlFilter.filter && layer.webGlFilter.filter[0] === "in"){
			var url = layer.url + "&typename=" + layer.typeName + "&outputformat=geojson&srs=EPSG:4326";
				$.ajax({
					url: url,
					dataType: "json",
					jsonp: false,
					success: function(featureCollection){
						featureCollection.features.forEach(function(f){
							let value = parseInt(f.properties[layer.filterValue]);
							if(layer.haystack.indexOf(value) === -1){
								layer.haystack.push(value);
							}								
						})
						layer.haystack.sort();
						privateFns.createDropDownFilter(layer);
					},
				});
		}
	},
	createDropDownFilter: function(lyrParams){
		let selectInput = creator.createDiv({id: "myMultiselect", css:"multiselect"});
		let selectLabel = creator.createDiv({id: "mySelectLabel", css:"selectBox", onclick: privateFns.toggleCheckboxArea});
		let formSelect = creator.createSelect({css: "form-select"});
		let dummyOption = creator.createOption({value: "somevalue"});
		let overSelect = creator.createDiv({css: "overSelect"});
		let selectOptions = creator.createDiv({id: "mySelectOptions"});
		formSelect.appendChild(dummyOption);
		selectLabel.appendChild(formSelect);
		selectLabel.appendChild(overSelect);
		selectInput.appendChild(selectLabel);
		
		for(let i = 0; i < lyrParams.haystack.length; i++){
			if(!document.getElementById(lyrParams.haystack[i])){	
				let optLabel = creator.createLabel({labelFor: lyrParams.haystack[i], text: lyrParams.haystack[i]});
				let opt = creator.createInput({id: lyrParams.haystack[i], type: "checkbox", onchange: function(){
					 privateFns.checkboxStatusChange(lyrParams)
				}, value: lyrParams.haystack[i]});
				optLabel.appendChild(opt);
				selectOptions.appendChild(optLabel);
			}
		}
		selectInput.appendChild(selectOptions);
		document.getElementById(lyrParams.layerId + "-filter").appendChild(selectInput);
	
		lyrParams.haystack = [];
		privateFns.initMultiselect();
	},
	updateLayer: function(lyrParams, checked){
		console.log(globals.map);
		console.log(globals.map.getInteractionById("featureclick"));
		console.log(globals.map.getLayerById("riving1990"));
		console.log(globals.map.getLayerById("riving1990").getProperties());
		let prevLayer = globals.map.getLayerById(lyrParams.layerId);
		let style =  {
			'circle-radius': 8,
			'circle-fill-color': ['match', ['get', 'hover'], 1, "rgba(110, 110, 110, 0.8)", lyrParams.fillColor],
			'circle-stroke-width': 2,
			'circle-stroke-color': 'darkblue',
		}
		if(checked.length > 0){
			style.filter =  ['in', ['get', 'SAKSAAR', 'number'], checked];
		}
		let newLayer = new WebGLPointsLayer({
			title: lyrParams.title,
			layerId: lyrParams.layerId,
			displayInLayerMenu: lyrParams.displayInLayerMenu,
			layerInfo: lyrParams.layerInfo || false,
			customLayerInfo: lyrParams.customLayerInfo || false,
			attribution: lyrParams.attribution || null,
			attributionId: lyrParams.attributionId || null,
			dependent: lyrParams.dependent || null,
			exclude: lyrParams.exclude || null,
			conditional: lyrParams.conditional || null,
			dontCascade: lyrParams.dontCascade || false,
			radio: lyrParams.radio,
			loadingTiles: 0,
			noToggle: lyrParams.noToggle || false,
			hiddenToggle: lyrParams.hiddenToggle || false,
			featureInfo: lyrParams.featureInfo,
			webGlFilter: lyrParams.webGlFilter,
			source: prevLayer.get("source"),
			style: style,
		});
		
		globals.map.addLayer(newLayer);
		
		if(prevLayer){
			globals.map.removeLayer(prevLayer);
			prevLayer.dispose();
		}
	},
	initMultiselect: function () {
	  privateFns.checkboxStatusChange();

	  document.addEventListener("click", function(evt) {
		var flyoutElement = document.getElementById('myMultiselect'),
		  targetElement = evt.target; // clicked element

		do {
		  if (targetElement == flyoutElement) {
			  privateFns.toggleCheckboxArea(false);
			// This is a click inside. Do nothing, just return.
			return;
		  }
		  // Go up the DOM
		  targetElement = targetElement.parentNode;
		} while (targetElement);

		// This is a click outside.
		privateFns.toggleCheckboxArea(true);
	  });
	},
	toggleCheckboxArea: function (onlyHide) {
		var checkboxes = document.getElementById("mySelectOptions");
		var displayValue = checkboxes.style.display;
		if (displayValue != "block") {
			if (onlyHide == false) {
				checkboxes.style.display = "block";
			}
		} else {
			checkboxes.style.display = "none";
		}
	},
	checkboxStatusChange: function (lyrParams) {
		var multiselect = document.getElementById("mySelectLabel");
		var multiselectOption = multiselect.getElementsByTagName('option')[0];

		var values = [];
		var checkboxes = document.getElementById("mySelectOptions");
		var checkedCheckboxes = checkboxes.querySelectorAll('input[type=checkbox]:checked');

		for (const item of checkedCheckboxes) {
			var checkboxValue = item.getAttribute('value');
			values.push(parseInt(checkboxValue));
		}

		var dropdownValue = "Ingenting er valgt";
		if (values.length > 0) {
			dropdownValue = values.join(', ');
		}
		if(lyrParams){		  
			privateFns.updateLayer(lyrParams, values);
		}

		multiselectOption.innerText = dropdownValue;
	},
	getParsed: function (currentFrom, currentTo) {
		const from = parseInt(currentFrom.value, 10);
		const to = parseInt(currentTo.value, 10);
		return [from, to];
	},
	
	controlFromSlider: function (minSlider, maxSlider, id) {
		let layer = globals.map.getLayerById(id);
		const [from, to] = privateFns.getParsed(minSlider, maxSlider);
		privateFns.fillSlider(minSlider, maxSlider, '#C6C6C6', '#25daa5', minSlider);
		if (from > to) {
			minSlider.value = to;
			document.getElementById(id+"-min-label").innerText = to;
			layer.values_.style.variables.min = parseInt(to);
		}else{
			document.getElementById(id+"-min-label").innerText = from;
			layer.values_.style.variables.min = parseInt(from);
		}
		globals.map.render();
	},
	controlToSlider: function (minSlider, maxSlider, id) {
		let layer = globals.map.getLayerById(id);
		const [from, to] = privateFns.getParsed(minSlider, maxSlider);
		privateFns.fillSlider(minSlider, maxSlider, '#C6C6C6', '#25daa5', minSlider);
		privateFns.setToggleAccessible(maxSlider, id);
		if (from <= to) {
			maxSlider.value = to;
			document.getElementById(id+"-max-label").innerText = to;
			layer.values_.style.variables.max = parseInt(to);
		} else {
			document.getElementById(id+"-max-label").innerText = from;
			maxSlider.value = from;
			layer.values_.style.variables.max = parseInt(from);
		}
		globals.map.render();
	},
	fillSlider: function (from, to, sliderColor, rangeColor, controlSlider) {
		const rangeDistance = to.max-to.min;
		const fromPosition = from.value - to.min;
		const toPosition = to.value - to.min;
		controlSlider.style.background = 'linear-gradient(to right, ${sliderColor} 0%, ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%, ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%, ${rangeColor} ${(toPosition)/(rangeDistance)*100}%, ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, ${sliderColor} 100%)';
	},
	setToggleAccessible: function (currentTarget, id) {
		const toSlider = document.querySelector('#'+ id);
		if (Number(currentTarget.value) <= 0 ) {
			toSlider.style.zIndex = 2;
		} else {
			toSlider.style.zIndex = 0;
		}
	},
	toggleLayerLoader: function (id, value) {
		$("#" + id).next().find(".layerloader").css("display", value);
	},
	toggleAttribution: function (layer, visible) {
		var id = layer.get("attributionId");
		var target = $("#" + id);

		var parentLayer = globals.map.getLayerById(layer.get("parentId"));
		var visibleSubLayer = false;
		if (parentLayer.get("attributionId") === layer.get("attributionId")) {
			visibleSubLayer = privateFns.getVisibleLayer(parentLayer);
		} else {
			globals.map.getLayersBy("attributionId", id).forEach(function (l) {
				if (l.getVisible()) {
					visibleSubLayer = true;
				}
			});
		}
		if (visible) {
			if (target.length === 0) {
				var element = creator.createSpan({id: id, css: "ui-link", text: layer.get("attribution")});
				$("#attribution-ct").append(element);
			}
		} else {
			if (visibleSubLayer === false) {
				target.remove();
			}
		}
	},
	toggleCssScreenSize: function(){
		var ww = document.body.clientWidth;
		if (ww < 1024) {
			$('.navtoggler').removeClass('navtogglerActive').addClass('navtoggler-toggled');
			$('.navtoggler').find("i").addClass("icon-Menu").removeClass("icon-Close");
		}else{
			$('.navtoggler').removeClass('navtoggler-toggled').addClass('navtogglerActive');
			//$('.navtoggler').find("i").addClass("icon-Menu").removeClass("icon-Close");
		}
	},
};
    
export default {
	initiate: function(layers, header){
		privateFns.createLayerMenuContainer(header);
		privateFns.createLayerinfoPage();
		privateFns.loopLayers(layers, document.getElementById("mapmenu-ct"));
		privateFns.toggleCssScreenSize();		
		$(window).resize(function(){
			privateFns.toggleCssScreenSize();				
		});
		privateFns.toggleDefaultLayers();
	},
	loopLayers: privateFns.loopLayers,
};